import React from "react";
import { cn } from "./cn";
import { ArrowRight } from "../../../assets/ui/icons";

/* A picker row: icon, title, supporting line, and a trailing arrow. */
const VARIANTS = {
  default:
    "border-[var(--line)] bg-white hover:border-[var(--line-2)] text-[var(--ink)]",
  // The suggested option: tinted surface and a coral edge.
  recommended:
    "border-[var(--coral)] bg-[var(--coral-soft)] hover:bg-[var(--coral-soft)] text-[var(--ink)]",
};

const ICON_VARIANTS = {
  default: "bg-[var(--slate-2)] text-[var(--ink-2)]",
  recommended: "bg-white text-[var(--coral)]",
};

export const ChoiceCard = ({
  icon,
  title,
  description,
  variant = "default",
  onClick = () => {},
  className = "",
  ...rest
}) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      "w-full flex items-start gap-3.5 p-4 rounded-xl border text-left transition-colors",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--orange)] focus-visible:ring-offset-2",
      VARIANTS[variant] || VARIANTS.default,
      className
    )}
    {...rest}
  >
    {icon && (
      <span
        aria-hidden="true"
        className={cn(
          "shrink-0 w-10 h-10 rounded-lg flex items-center justify-center",
          ICON_VARIANTS[variant] || ICON_VARIANTS.default
        )}
      >
        {icon}
      </span>
    )}

    <span className="flex-1 min-w-0">
      <span className="block text-[15px] font-bold font-sans">{title}</span>
      {description && (
        <span className="block mt-0.5 text-[13px] leading-[1.45] text-[var(--muted)] font-sans">
          {description}
        </span>
      )}
    </span>

    <span
      aria-hidden="true"
      className={cn(
        "shrink-0 self-center",
        variant === "recommended" ? "text-[var(--coral)]" : "text-[var(--muted-2)]"
      )}
    >
      <ArrowRight size={15} />
    </span>
  </button>
);

export default ChoiceCard;
